import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { API, useAuth } from "../../context/AuthContext";
import { Flame, Trophy, Timer } from "lucide-react";

const fmt = (s) => `${String(Math.floor(s / 3600)).padStart(2, "0")}:${String(Math.floor((s % 3600) / 60)).padStart(2, "0")}:${String(s % 60).padStart(2, "0")}`;

export default function DailyStageHero({ compact = false }) {
  const { user } = useAuth();
  const [t, setT] = useState(null); const [left, setLeft] = useState(0);
  useEffect(() => { axios.get(`${API}/daily/today`).then(r => { setT(r.data); setLeft(r.data.seconds_to_next); }).catch(() => {}); }, [user]);
  useEffect(() => { const i = setInterval(() => setLeft(l => Math.max(0, l - 1)), 1000); return () => clearInterval(i); }, []);
  if (!t) return null;
  const me = t.me;
  return (
    <section className={`${compact ? "" : "max-w-7xl mx-auto px-5 lg:px-8 -mt-6 mb-10"}`} data-testid="daily-stage-hero">
      <div className="rl-banner rl-watermark p-6 md:p-8 flex flex-wrap items-center gap-6 border border-[#FF9F0A]/40">
        <div className="relative flex-1 min-w-[220px]">
          <div className="pill-badge pill-amber mb-2"><Flame className="w-3 h-3" /> DAILY STAGE · {me?.played ? "GIOCATA OGGI" : "NUOVA PROVA DISPONIBILE"}</div>
          <h2 className="font-display font-black text-3xl md:text-5xl leading-none">Una nuova prova.<br />Ogni giorno.</h2>
          <p className="text-slate-400 text-sm mt-2">5 prove, 90 secondi, gratis per sempre. Quiz · Auto · Pilota · Note · Reaction Start.</p>
          <div className="flex flex-wrap gap-4 mt-4 text-xs font-mono-rl text-slate-300">
            <span className="flex items-center gap-1" data-testid="daily-countdown"><Timer className="w-4 h-4 text-[#FF9F0A]" /> PROSSIMA TRA {fmt(left)}</span>
            {me && <><span className="flex items-center gap-1" data-testid="daily-streak"><Flame className="w-4 h-4 text-[#FF1E27]" /> STREAK {me.streak}</span><span className="flex items-center gap-1" data-testid="daily-best"><Trophy className="w-4 h-4 text-[#30D158]" /> RECORD {me.best_score}</span>{me.rank && <span data-testid="daily-rank">OGGI P{me.rank}</span>}</>}
            <span>{t.participants} FAN OGGI</span>
          </div>
        </div>
        <div className="relative">
          <Link to={user ? "/daily" : "/register?next=/daily"} className="btn-crimson text-lg !px-8 !py-4 min-h-[60px] flex items-center justify-center" data-testid="daily-play-btn">{me?.played ? "VEDI RISULTATO E ALLENATI" : "GIOCA GRATIS"}</Link>
        </div>
      </div>
    </section>
  );
}
